import { render, staticRenderFns } from "./icon-show.svg.vue?vue&type=template&id=5b2f3432&"
import script from "./icon-show.svg.vue?vue&type=script&lang=js&"
export * from "./icon-show.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports